import React from "react";
import "../css/Home.css"; 
 
const Home = () => {
  return (
    <div className="home-main">
        <div>
        <h1>Student Connect</h1>
        <h2>The AI Code Editor</h2>
        <p>Built to make you extraordinarily productive, Student Connect is the best way to code with AI.</p>
        </div>
      
        <div className="button-group">
          <a href="/StudentConnect.exe" download>
            <button className="btn black-btn">Download for Windows</button>
          </a>
        </div>
    </div>
  );
};

export default Home;
